import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Oregon Ducks"
    subtitle="See the Oregon Ducks in action this season"
    hasGenericVideo={true}
    teamId={teamIds['Oregon Ducks']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Ducks.png"
  />
)
